import {
  ChangeDetectionStrategy,
  Component,
  Input,
  input,
  output
} from '@angular/core';

import { Attachment, ContactType } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';
import { ImmomioButtonComponent } from '@immomio/ui/button';

import { MessageTimePipe } from '../../../../../pipes/message-time.pipe';
import { FullNamePipe } from '../../../../../pipes/full-name.pipe';
import { ImageSizePipe } from '../../../../../pipes/image-size.pipe';
import { DateTimePipe } from '../../../../../pipes/date-time.pipe';
import { ChatAttachmentComponent } from '../chat-attachment/chat-attachment.component';
import { AvatarComponent } from '../../../avatar/avatar.component';
import {
  Conversation,
  ConversationMessage,
  ConversationMessagesCSSCLass,
  MessageTemplate
} from '../../model/interface';

@Component({
  selector: 'app-chat-text-message',
  templateUrl: './chat-text-message.component.html',
  styleUrls: ['./chat-text-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarComponent,
    ChatAttachmentComponent,
    ImmomioButtonComponent,
    ImmomioTooltipDirective,
    TranslatePipe,
    DateTimePipe,
    ImageSizePipe,
    FullNamePipe,
    MessageTimePipe
  ]
})
export class ChatTextMessageComponent {
  private _groupCssClass: string;
  readonly message = input<ConversationMessage>(undefined);
  readonly sender = input<ContactType>(undefined);
  readonly activeConversation = input<Conversation>(undefined);

  @Input() get groupCssClass(): string {
    return this._groupCssClass;
  }

  set groupCssClass(value: string) {
    this._groupCssClass = value;
    this.showImage = this.getShowImage();
  }

  readonly isLandlord = input<boolean>(undefined);
  readonly isPropertySearcher = input<boolean>(undefined);

  readonly download = output<Attachment>();
  readonly preview = output<Attachment>();
  readonly createMessageAsTemplate = output<MessageTemplate>();

  public showImage: boolean;
  private xssRegEx = new RegExp(
    // eslint-disable-next-line no-control-regex
    '(\b)(onS+)(s*)=|javascript|(<s*)(/*)script',
    'gi'
  );

  private getShowImage() {
    return (
      this.groupCssClass === ConversationMessagesCSSCLass.SINGLE ||
      this.groupCssClass === ConversationMessagesCSSCLass.FIRST
    );
  }

  public onCheckMessage(message: string) {
    if (this.xssRegEx.exec(message)?.length > 0) {
      return '';
    }
    return message;
  }

  public onDownload(attachment: Attachment) {
    this.download.emit(attachment);
  }

  public onPreview(attachment: Attachment) {
    this.preview.emit(attachment);
  }

  public creatingMessageAsTemplate(messageData: ConversationMessage) {
    if (!this.isLandlord()) return;
    const { attachments, message: content } = messageData;
    this.createMessageAsTemplate.emit({
      content: content.replace(/<br \/>/gi, '\n'),
      attachments: attachments?.[0]
    });
  }
}
